import { Backdrop, Button, Paper, styled } from "@mui/material";
import colors from "theme/themeConstants";
import linkIconRed from "components/icons/share-red.svg";
import privateGifIconRed from "components/icons/privateGifIconRed.svg";
import publicGifIconRed from "components/icons/publicGifIconRed.svg";
import trashcanIconRed from "components/icons/trashcanIconRed.svg";
import galleryIcon from "components/icons/gallery.svg";
// import nicheIcon from "components/icons/FolderAdd2.svg";
import React, { MouseEvent, useCallback } from "react";
import { IGif } from "services/types";

interface IProps {
  gif: IGif;
  onShare: () => void;
  onAddToNiche: () => void;
  onChangeVisibility: () => void;
  onDelete: () => void;
  onClose: () => void;
  onEditGallery?: (gallery?: string) => void;
}

export const GifOptionsMobile = (props: IProps) => {
  const {
    gif,
    onShare,
    onChangeVisibility,
    onDelete,
    onClose,
    onEditGallery,
    // onAddToNiche
  } = props;

  const handleStopPropagation = useCallback((event: MouseEvent) => {
    event.stopPropagation();
  }, []);

  return (
    <Backdrop
      open={true}
      id={"popupOpen"}
      sx={{
        zIndex: "var(--popupZ)"
      }}
      onClick={onClose}
    >
      <Paper onClick={handleStopPropagation} sx={{
        height: "auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        maxWidth: "25rem",
        position: "absolute",
        bottom: "0rem",
        transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
        margin: "0",
        borderRadius: "24px",
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
        padding: "2rem 1rem 0 1rem",
        "@media screen and (max-width: 767px)": {
          borderRadius: 0,
          maxWidth: "unset",
          borderTopLeftRadius: "24px",
          borderTopRightRadius: "24px",
        }
      }}>

        <MobileHandler
          onClick={onClose}
        />

        <FlexContainer>
          <h3 style={{ fontSize: "20px", fontWeight: 500, }}>Options:</h3>
        </FlexContainer>

        <FlexContainer sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "8px",
          margin: "1.5rem 0 2rem",
          "& button": {
            padding: 0,
            borderRadius: "12px",
            "& div": {
              backgroundColor: colors.lightGrayPaperBackground,
              width: "44vw",
              borderRadius: "12px",
              height: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "& img": {
              maxHeight: "28px",
            },
            "& p": {
              marginLeft: "6px",
            },
            "&:last-child:nth-of-type(odd)": {
              width: "100% !important",
              "& div": {
                width: "100% !important",
              }
            }
          }
        }}>

          <Button onClick={onShare}>
            <Paper elevation={0} >
              <img src={linkIconRed} alt="" />
              <p>Share</p>
            </Paper>
          </Button>

          <Button onClick={onChangeVisibility}>
            <Paper elevation={0} >
              <img
                style={{ fill: colors.redPink }}
                src={gif.published ? privateGifIconRed : publicGifIconRed}
                alt=""
              />
              <p>{`Make ${gif.published ? "private" : "public"}`}</p>
            </Paper >
          </Button>

          <Button onClick={onDelete}>
            <Paper elevation={0} >
              <img
                style={{ fill: colors.redPink }}
                src={trashcanIconRed}
                alt=""
              />
              <p>Delete</p>
            </Paper >
          </Button>

          {
            onEditGallery && gif.gallery && (
              <Button onClick={ () => { onEditGallery(gif.gallery); } }>
                <Paper elevation={0} >
                  <img src={galleryIcon} alt="" />
                  <p>Edit Gallery</p>
                </Paper>
              </Button>
            )
          }
        </FlexContainer >
      </Paper >
    </Backdrop >
  );
};

const FlexContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  width: "100%"
});

const MobileHandler = styled("div")({
  background: "rgba(216, 223, 236, 0.7)",
  borderRadius: "12px",
  width: "32px",
  height: "4px",
  alignSelf: "center",
  marginBottom: "1rem"
});
